import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwitzerlandFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M30.0005 0.000488292C35.934 0.000597581 41.7341 1.76017 46.6675 5.05669C51.6009 8.35321 55.446 13.0386 57.7166 18.5204C59.9871 24.0022 60.5811 30.0342 59.4235 35.8536C58.2658 41.673 55.4085 47.0185 51.2129 51.214C47.0173 55.4095 41.6718 58.2666 35.8523 59.4241C30.0329 60.5816 24.0009 59.9874 18.5192 57.7167C13.0374 55.446 8.35212 51.6008 5.05574 46.6673C1.75935 41.7338 -5.53905e-05 35.9336 1.30789e-09 30.0002C1.98796e-06 26.0605 0.775996 22.1594 2.28368 18.5196C3.79136 14.8798 6.00119 11.5727 8.78701 8.78691C11.5728 6.00117 14.8801 3.79142 18.5199 2.28385C22.1597 0.776267 26.0609 0.000380934 30.0005 0.000488292V0.000488292Z",
		fill: "#ED4C5C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M45.0002 25.0006H35.0001V15.0005H25.0004V25.0006H15V35.0006H25.0004V45.0007H35.0001V35.0006H45.0002V25.0006Z",
		fill: "white"
	})]
});
export default SvgSwitzerlandFlag;
